<template>
  <div class="termsOfService">
    <div class="main">
      <Markdown
        :content="content"
        :products="products"
      />
    </div>
  </div>
</template>

<script>
import Markdown from '@/components/mark-down';

import TermsOfService from '@docs/docs/terms-of-service.md';

export default {
  name: 'TermsOfService',
  components: {
    Markdown,
  },
  data() {
    return {
      content: TermsOfService,
    };
  },
  computed: {
    products() {
      return {
        APP_TITLE: this.APP_TITLE,
        EXTENSION_NAME: this.EXTENSION_NAME,
        SUPPORT_EMAIL: this.SUPPORT_EMAIL,
        DISCORD_URL: this.DISCORD_URL,
        HOME_URL: this.HOME_URL,
        BLOG_URL: this.BLOG_URL,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.termsOfService {
  overflow: auto;
  width: 100%;

  .main {
    max-width: 1200px;
    width: 80%;
    margin: 0 auto;
  }
}
</style>